import { baseAPI } from './baseApi';

export const AiSummaryApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getDealSummary: builder.query({
      query: (listingId) => ({
        url: `/api/analyzeExpose/ai/deal-summary/${listingId}`,
      }),
      // Kein automatisches Cachen pro Tag — on-demand laden
    }),
  }),
});

export const { useGetDealSummaryQuery, useLazyGetDealSummaryQuery } = AiSummaryApi;
